import React from 'react';
import { Link } from 'react-router-dom';
import '../pages/landing/landing.css';

// Full-page message in the landing style: a report that is still being
// prepared, a payment being confirmed, an error. `busy` adds the scanning
// bar; children go under the title (explanation, buttons).
const StatusScreen = ({ kicker, title, busy = false, children }) => (
  <div className="lp flex min-h-screen flex-col">
    <header className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 lg:px-8">
      <Link to="/" className="lp-display text-2xl">
        webspector<span className="text-[var(--lp-lime)]">.</span>
      </Link>
    </header>
    <main className="mx-auto flex w-full max-w-6xl flex-1 flex-col justify-center px-4 pb-24 sm:px-6 lg:px-8" role="status">
      <p className="lp-kicker">{kicker}</p>
      <h1 className="lp-display mt-5 max-w-3xl text-[clamp(2.6rem,6.5vw,5rem)]">{title}</h1>
      {busy && (
        <div className="mt-10 h-[3px] w-full max-w-2xl overflow-hidden rounded-full bg-[var(--lp-line)]">
          <div className="lp-scan h-full w-full" />
        </div>
      )}
      {children}
    </main>
  </div>
);

export const StatusText = ({ children }) => (
  <p className="mt-8 max-w-xl text-lg leading-relaxed text-[var(--lp-muted)]">{children}</p>
);

export default StatusScreen;
